import React, { useState, useEffect } from 'react'
import Slider from 'react-slick'
import { useDispatch, useSelector } from 'react-redux'
import { generatePresignedURL, CloudFileUpload } from '../../../Redux/Actions/cloudFileUpload'
import './style.css'
import { deleteSubmission, introVideoDetails, secondStepDetails, togglePublic, updateIntroVideo } from '../../../Redux/Actions/ProfileSteps'
import VideoSection from './components/videosection'
import { Loading } from 'notiflix'
import ReactPlayer from 'react-player'

const IntroductionVideo = ({ setCurrentStep }) => {
  const [loading, setLoading] = useState(false)
  const [videoFile, setVideoFile] = useState(null)
  const [videoPreview, setVideoPreview] = useState(null)
  const [isDragging, setIsDragging] = useState(false)
  const [error, setError] = useState('')
  const [playingId, setPlayingId] = useState(null)
  const boxData = [
    '💡 Text resumes look the same. Your voice and energy are unique, add a video to your portfolio in less than a minute!',
    "💡 Profiles with video have a 3x higher recall rate. Upload a simple short video to your portfolio and turn a 'maybe' into a 'yes.'",
    "💡 Don't leave your profile at 90%. That last 10%—the video—is what bridges the gap between you and your dream team.",
    '💡 It takes less than 2 minutes to record a clip that proves your communication skills are as good as your resume says they are.',
    "💡 You wouldn't walk into an interview without saying hello. Don't let your profile be silent. The first impression happens before the interview now.",
    '💡 Did you know? Recruiters spend 3x more time on profiles with video, add a video to your portfolio in less than a minute!',
  ]
  const [localData, setLocalData] = useState([])
  const [localLoading, setLocalLoading] = useState({})

  const dispatch = useDispatch()
  const kids = useSelector((state) => state.dashboard.kids)
  const profileData = useSelector((s) => s.ProfileSteps.profileData)
  const SecondStepData = useSelector((s) => s.ProfileSteps.SecondStepData)
  const data = useSelector((s) => s.ProfileSteps.introData)
  useEffect(() => {
    // kids && kids[0]?.id && dispatch(fetchNormalSubmission({ kid_id: kids[0]?.id,"activity_id":1176 }))
    kids && kids[0]?.id && dispatch(secondStepDetails({ kid_id: kids[0]?.id }))
    kids && kids[0]?.id && dispatch(introVideoDetails({ kid_id: kids[0]?.id }))
  }, [kids])

  useEffect(() => {
    if (data) {
      setLocalData(data)
    }
  }, [data])

  useEffect(() => {
    return () => {
      if (videoPreview) {
        URL.revokeObjectURL(videoPreview)
      }
    }
  }, [videoPreview])

  useEffect(() => {
    if (loading) Loading.standard('Uploading...')
    else Loading.remove()
  }, [loading])

  const handleTogglePublic = (submissionId) => {
    setLocalLoading((prev) => ({ ...prev, [submissionId]: true }))

    setLocalData((prev) => prev.map((item) => (item.csnUniqueId === submissionId ? { ...item, isPublic: !item.isPublic } : item)))

    dispatch(togglePublic({ submissionId }))
      .then(() => {
        setLocalLoading((prev) => ({ ...prev, [submissionId]: false }))
      })
      .catch(() => {
        setLocalData((prev) => prev.map((item) => (item.csnUniqueId === submissionId ? { ...item, isPublic: !item.isPublic } : item)))
        setLocalLoading((prev) => ({ ...prev, [submissionId]: false }))
      })
  }

  const handleDeleteSubmission = (submissionId) => {
    setLocalLoading((prev) => ({ ...prev, [submissionId]: true }))

    const itemIndex = localData?.findIndex((item) => item.csnUniqueId === submissionId)
    const deletedItem = localData[itemIndex]

    setLocalData((prev) => prev.filter((item) => item.csnUniqueId !== submissionId))

    if (playingId === submissionId) {
      setPlayingId(null)
    }

    dispatch(deleteSubmission(submissionId))
      .then(() => {
        setLocalLoading((prev) => ({ ...prev, [submissionId]: false }))
      })
      .catch(() => {
        setLocalData((prev) => [...prev, deletedItem])
        setLocalLoading((prev) => ({ ...prev, [submissionId]: false }))
      })
  }

  const validateAndSetVideo = (file) => {
    setError('')

    if (!file) {
      setError('Please select a file')
      return
    }

    if (!file.type.startsWith('video/mp4')) {
      setError('Only MP4 files are allowed')
      return
    }

    const maxSize = 2500 * 1024 * 1024
    if (file.size > maxSize) {
      setError('File size must be less than 25MB')
      return
    }

    const previewUrl = URL.createObjectURL(file)
    setVideoFile(file)
    setVideoPreview(previewUrl)
  }

  const handleDragEnter = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(true)
  }

  const handleDragLeave = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(false)
  }

  const handleDragOver = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setIsDragging(false)
    const file = e.dataTransfer.files[0]
    validateAndSetVideo(file)
  }

  const handleVideoChange = (e) => {
    const file = e.target.files[0]
    validateAndSetVideo(file)
  }

  const removeVideo = () => {
    if (videoPreview) {
      URL.revokeObjectURL(videoPreview)
    }
    setVideoFile(null)
    setVideoPreview(null)
    setError('')
  }

  const handleNext = async () => {
    try {
      if (!videoFile) {
        setCurrentStep(3)
        return
      }

      setLoading(true)

      const presignedUrl = await new Promise((resolve, reject) => {
        dispatch(
          generatePresignedURL({ filetype: 'video' }, (url) => {
            if (!url) return reject(new Error('Presigned URL not received'))
            resolve(url)
          }),
        )
      })

      const uploadedUrl = await new Promise((resolve, reject) => {
        dispatch(
          CloudFileUpload({ url: presignedUrl, file: videoFile, type: 'video' }, (imageUrl) => {
            if (!imageUrl) return reject(new Error('Upload URL not received'))
            resolve(imageUrl)
          }),
        )
      })

      await dispatch(
        updateIntroVideo({
          kid_id: kids[0]?.id,
          intro_video_url: uploadedUrl,
        }),
      )

      setCurrentStep(3)
    } catch (error) {
      console.error('Upload failed:', error)
      alert('Upload failed. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="intro-video-step">
      <div className="container-fluid px-lg-5">
        <div className="content-box gr-box">
          <h2 className="mb-3 mb-lg-4">What do you need to do?</h2>
          <div className="d-flex">
            <img src="./images/image158.png" alt="" className="mb-auto" />
            <div className="flex-1 ms-3 ms-lg-4">
              <h2 className="mb-2">{SecondStepData?.name}</h2>
              <p className="col-md-7">{SecondStepData?.activity_introduction?.objective?.[0]}</p>
            </div>
          </div>
          <p className="col-md-7 pt-4">{SecondStepData?.activity_introduction?.objective?.[1]}</p>
          <p className="col-md-7 pt-4">{SecondStepData?.activity_introduction?.objective?.[2]}</p>
          <p className="col-md-7 pt-4">{SecondStepData?.activity_introduction?.objective?.[3]}</p>
        </div>
        <div className="content-box px-0">
          <h2 className="mb-3 mb-lg-4">Instructions</h2>
          <ol className="ps-3 col-md-7">
            {SecondStepData?.activity_instructions?.preparation?.map((item) => {
              return <li>{item}</li>
            })}
          </ol>
        </div>
        <div className="content-box bg-yellow">
          <p className="col-md-7">{boxData[Math.floor(Math.random() * boxData.length)]}</p>
        </div>

        <div className="content-box px-0">
          <h2 className="mb-3 mb-lg-4 text-dark">Basic skill showcase</h2>
          <p className="col-md-7">
            You can watch these reference videos to understand what a strong response looks like. Use them to learn, refine your approach, and deliver your best performance. A better submission
            strengthens your portfolio and increases your chances of landing a job.
          </p>
        </div>
        <div class="col-md-7">
          <VideoSection />
        </div>
        <div className="content-box d-flex justify-content-between align-items-center col-md-7 bg-yellow-gr">
          <img src="./images/layer.png" alt="" />
          <h2 className="m-0 text-black fw-normal fs-14 ps-4">{boxData[Math.floor(Math.random() * boxData.length)]}</h2>
        </div>

        <div className="form-bg px-0 bg-transparent col-md-7">
          <div className="form-group">
            <label htmlFor="">Upload your video</label>

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            {!videoFile ? (
              <div
                className={`drop-uploader ${isDragging ? 'dragging' : ''}`}
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => document.getElementById('videoUpload').click()}
                style={{ cursor: 'pointer' }}
              >
                <div>
                  <img src="./svg/download.svg" alt="" className="mb-3" />
                  <p>
                    MP4 file <br />
                    Size: Max 25MB
                  </p>
                </div>
              </div>
            ) : (
              <div className="col-md-6">
                <div className="drop-uploader flex-column p-3 position-relative">
                  <video src={videoPreview} controls style={{ width: '100%', maxHeight: '300px' }}>
                    Your browser does not support the video tag.
                  </video>
                  <p className="mt-2 mb-2">
                    <strong>{videoFile.name}</strong>
                  </p>
                  <p className="text-muted mb-0">Size: {(videoFile.size / (1024 * 1024)).toFixed(2)} MB</p>
                  <button
                    onClick={removeVideo}
                    className="remove-btn"
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: '#fff',
                      border: 'none',
                      borderRadius: '50%',
                      padding: '8px',
                      cursor: 'pointer',
                    }}
                  >
                    <img src="./svg/trash.svg" alt="delete" />
                  </button>
                </div>
              </div>
            )}

            <input id="videoUpload" type="file" accept="video/mp4" onChange={handleVideoChange} style={{ display: 'none' }} />
          </div>

          <div className="content-box px-0 skill-showcase">
            <p>
              Kindly record your video in landscape mode and be dressed in professional attire. Read the activity details carefully, and feel free to integrate any supporting material into your video
              for clarity. Only your latest submission appears in your portfolio, so make sure it reflects your best work.
            </p>
          </div>
        </div>

        <div className="content-box px-0">
          <h2 className="mb-3 mb-lg-4 text-dark">Previous Submissions</h2>
          <p className="mb-3 mb-lg-4 text-dark">*Note : The video(s) displayed in your portfolio will be shared with companies as part of the job application process.</p>
          <div className="row">
            {localData &&
              localData?.map((item, idx) => {
                const id = item?.csnUniqueId ?? idx

                return (
                  <div className="col-lg-4 mb-5" key={id}>
                    <div>
                      <h3 className="video-title">{item?.activityName}</h3>
                      <div>
                        <ReactPlayer
                          key={item?.fileUrlDtoList?.[0]?.fileUrl}
                          url={item?.fileUrlDtoList?.[0]?.fileUrl}
                          controls={true}
                          height={'100%'}
                          width={'100%'}
                          className="summary-video "
                          playing={playingId === id}
                          onPlay={() => setPlayingId(id)}
                          onPause={() => {
                            if (playingId === id) setPlayingId(null)
                          }}
                          onEnded={() => {
                            if (playingId === id) setPlayingId(null)
                          }}
                        />
                      </div>

                      <div className="d-flex justify-content-between mt-3">
                        <label className="toggle-switch-main mb-0">
                          <span className="toggle-label">Show in Portfolio</span>
                          <input className="toggle-checkbox" type="checkbox" checked={item?.isPublic} disabled={localLoading[id]} onChange={() => handleTogglePublic(item?.csnUniqueId)} />
                          <div className="toggle-switch" />
                        </label>

                        <button type="button" className="p-0 bg-transparent border-0" onClick={() => handleDeleteSubmission(item?.csnUniqueId)} disabled={localLoading[id]} aria-label="Delete">
                          {localLoading[id] ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <img src="./svg/trash.svg" alt="Delete" />}
                        </button>
                      </div>
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      </div>

      <div className="btn-footer">
        <div className="container-fluid d-flex justify-content-lg-end">
          <button className="default-btn default-border bg-transparent back-btn me-3" onClick={() => setCurrentStep(1)}>
            <img src="./images/back-arrow.png" className="d-block d-md-none" />
            <span className="d-none d-md-block">Back</span>
          </button>
          <button className="default-btn default-border bg-transparent me-3" onClick={() => setCurrentStep(3)}>
            Skip
          </button>
          <button className="default-btn" onClick={handleNext}>
            Save & Next
          </button>
        </div>
      </div>
    </div>
  )
}

export default IntroductionVideo
